module.exports = __webpack_public_path__ + "assets/notification_level.f571f769.svg";